/**
 * @author Magebit <info@magebit.com>
 * @copyright Copyright (c) Magebit, Ltd. (https://magebit.com)
 * @license https://magebit.com/code-license
 */

const seoCityRedirects: Record<string, Record<string, string>> = {
  'alla-evenemang/kategorier/konsert': {
    '24': 'alla-evenemang/kategorier/konsert/stockholm',
    '85': 'alla-evenemang/kategorier/konsert/goteborg',
    '114': 'alla-evenemang/kategorier/konsert/linkoping',
    '112': 'alla-evenemang/kategorier/konsert/malmo',
    '120': 'alla-evenemang/kategorier/konsert/uppsala',
    '94': 'alla-evenemang/kategorier/konsert/helsingborg',
    '110': 'alla-evenemang/kategorier/konsert/orebro',
    '123': 'alla-evenemang/kategorier/konsert/jonkoping',
    '160': 'alla-evenemang/kategorier/konsert/norrkoping',
    '116': 'alla-evenemang/kategorier/konsert/umea',
    '108': 'alla-evenemang/kategorier/konsert/karlstad',
    '162': 'alla-evenemang/kategorier/konsert/vasteras',
    '186': 'alla-evenemang/kategorier/konsert/gavle',
    '104': 'alla-evenemang/kategorier/konsert/halmstad',
    '163': 'alla-evenemang/kategorier/konsert/vaxjo',
    '187': 'alla-evenemang/kategorier/konsert/lund',
    '97': 'alla-evenemang/kategorier/konsert/varberg',
    '158': 'alla-evenemang/kategorier/konsert/kalmar',
    '117': 'alla-evenemang/kategorier/konsert/ostersund',
    '96': 'alla-evenemang/kategorier/konsert/sundsvall',
    '159': 'alla-evenemang/kategorier/konsert/lulea',
    '177': 'alla-evenemang/kategorier/konsert/falun',
    '118': 'alla-evenemang/kategorier/konsert/eskilstuna',
    '121': 'alla-evenemang/kategorier/konsert/kristianstad',
    '221': 'alla-evenemang/kategorier/konsert/skovde',
    '437': 'alla-evenemang/kategorier/konsert/falkenberg',
    '105': 'alla-evenemang/kategorier/konsert/rattvik',
    '127': 'alla-evenemang/kategorier/konsert/boras',
    '324': 'alla-evenemang/kategorier/konsert/trollhattan',
    '228': 'alla-evenemang/kategorier/konsert/visby',
    '414': 'alla-evenemang/kategorier/konsert/uddevalla',
    '299': 'alla-evenemang/kategorier/konsert/lysekil',
    '106': 'alla-evenemang/kategorier/konsert/karlskrona',
    '109': 'alla-evenemang/kategorier/konsert/nykoping',
    '107': 'alla-evenemang/kategorier/konsert/pitea',
    '124': 'alla-evenemang/kategorier/konsert/sandviken',
    '344': 'alla-evenemang/kategorier/konsert/motala',
    '125': 'alla-evenemang/kategorier/konsert/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/konsert/soderhamn',
    '323': 'alla-evenemang/kategorier/konsert/bollnas',
    '453': 'alla-evenemang/kategorier/konsert/karlshamn',
    '522': 'alla-evenemang/kategorier/konsert/vanersborg',
    '100': 'alla-evenemang/kategorier/konsert/vadstena',
    '251': 'alla-evenemang/kategorier/konsert/kungsbacka',
    '119': 'alla-evenemang/kategorier/konsert/lidkoping',
    '424': 'alla-evenemang/kategorier/konsert/alingsas',
    '425': 'alla-evenemang/kategorier/konsert/hassleholm',
    '439': 'alla-evenemang/kategorier/konsert/soderkoping',
    '130': 'alla-evenemang/kategorier/konsert/stenungsund',
    '126': 'alla-evenemang/kategorier/konsert/arvika',
    '102': 'alla-evenemang/kategorier/konsert/borgholm',
    '362': 'alla-evenemang/kategorier/konsert/jarvso',
    '111': 'alla-evenemang/kategorier/konsert/furuvik',
    '122': 'alla-evenemang/kategorier/konsert/huskvarna'
  },
  'alla-evenemang/kategorier/festival': {
    '24': 'alla-evenemang/kategorier/festival/stockholm',
    '94': 'alla-evenemang/kategorier/festival/helsingborg',
    '112': 'alla-evenemang/kategorier/festival/malmo',
    '162': 'alla-evenemang/kategorier/festival/vasteras',
    '85': 'alla-evenemang/kategorier/festival/goteborg',
    '121': 'alla-evenemang/kategorier/festival/kristianstad',
    '120': 'alla-evenemang/kategorier/festival/uppsala',
    '104': 'alla-evenemang/kategorier/festival/halmstad',
    '159': 'alla-evenemang/kategorier/festival/lulea',
    '116': 'alla-evenemang/kategorier/festival/umea',
    '118': 'alla-evenemang/kategorier/festival/eskilstuna',
    '114': 'alla-evenemang/kategorier/festival/linkoping',
    '110': 'alla-evenemang/kategorier/festival/orebro',
    '108': 'alla-evenemang/kategorier/festival/karlstad',
    '96': 'alla-evenemang/kategorier/festival/sundsvall',
    '186': 'alla-evenemang/kategorier/festival/gavle',
    '97': 'alla-evenemang/kategorier/festival/varberg',
    '160': 'alla-evenemang/kategorier/festival/norrkoping',
    '123': 'alla-evenemang/kategorier/festival/jonkoping',
    '177': 'alla-evenemang/kategorier/festival/falun',
    '158': 'alla-evenemang/kategorier/festival/kalmar',
    '117': 'alla-evenemang/kategorier/festival/ostersund',
    '437': 'alla-evenemang/kategorier/festival/falkenberg',
    '187': 'alla-evenemang/kategorier/festival/lund',
    '163': 'alla-evenemang/kategorier/festival/vaxjo',
    '127': 'alla-evenemang/kategorier/festival/boras',
    '324': 'alla-evenemang/kategorier/festival/trollhattan',
    '414': 'alla-evenemang/kategorier/festival/uddevalla',
    '228': 'alla-evenemang/kategorier/festival/visby',
    '221': 'alla-evenemang/kategorier/festival/skovde',
    '105': 'alla-evenemang/kategorier/festival/rattvik',
    '299': 'alla-evenemang/kategorier/festival/lysekil',
    '106': 'alla-evenemang/kategorier/festival/karlskrona',
    '109': 'alla-evenemang/kategorier/festival/nykoping',
    '107': 'alla-evenemang/kategorier/festival/pitea',
    '124': 'alla-evenemang/kategorier/festival/sandviken',
    '344': 'alla-evenemang/kategorier/festival/motala',
    '125': 'alla-evenemang/kategorier/festival/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/festival/soderhamn',
    '323': 'alla-evenemang/kategorier/festival/bollnas',
    '453': 'alla-evenemang/kategorier/festival/karlshamn',
    '522': 'alla-evenemang/kategorier/festival/vanersborg',
    '100': 'alla-evenemang/kategorier/festival/vadstena',
    '251': 'alla-evenemang/kategorier/festival/kungsbacka',
    '119': 'alla-evenemang/kategorier/festival/lidkoping',
    '424': 'alla-evenemang/kategorier/festival/alingsas',
    '425': 'alla-evenemang/kategorier/festival/hassleholm',
    '439': 'alla-evenemang/kategorier/festival/soderkoping',
    '130': 'alla-evenemang/kategorier/festival/stenungsund',
    '126': 'alla-evenemang/kategorier/festival/arvika',
    '102': 'alla-evenemang/kategorier/festival/borgholm',
    '362': 'alla-evenemang/kategorier/festival/jarvso',
    '111': 'alla-evenemang/kategorier/festival/furuvik',
    '122': 'alla-evenemang/kategorier/festival/huskvarna'
  },
  'alla-evenemang/kategorier/teater': {
    '24': 'alla-evenemang/kategorier/teater/stockholm',
    '110': 'alla-evenemang/kategorier/teater/orebro',
    '85': 'alla-evenemang/kategorier/teater/goteborg',
    '112': 'alla-evenemang/kategorier/teater/malmo',
    '121': 'alla-evenemang/kategorier/teater/kristianstad',
    '158': 'alla-evenemang/kategorier/teater/kalmar',
    '97': 'alla-evenemang/kategorier/teater/varberg',
    '120': 'alla-evenemang/kategorier/teater/uppsala',
    '162': 'alla-evenemang/kategorier/teater/vasteras',
    '114': 'alla-evenemang/kategorier/teater/linkoping',
    '123': 'alla-evenemang/kategorier/teater/jonkoping',
    '108': 'alla-evenemang/kategorier/teater/karlstad',
    '127': 'alla-evenemang/kategorier/teater/boras',
    '160': 'alla-evenemang/kategorier/teater/norrkoping',
    '437': 'alla-evenemang/kategorier/teater/falkenberg',
    '104': 'alla-evenemang/kategorier/teater/halmstad',
    '94': 'alla-evenemang/kategorier/teater/helsingborg',
    '187': 'alla-evenemang/kategorier/teater/lund',
    '159': 'alla-evenemang/kategorier/teater/lulea',
    '96': 'alla-evenemang/kategorier/teater/sundsvall',
    '186': 'alla-evenemang/kategorier/teater/gavle',
    '118': 'alla-evenemang/kategorier/teater/eskilstuna',
    '116': 'alla-evenemang/kategorier/teater/umea',
    '163': 'alla-evenemang/kategorier/teater/vaxjo',
    '177': 'alla-evenemang/kategorier/teater/falun',
    '221': 'alla-evenemang/kategorier/teater/skovde',
    '324': 'alla-evenemang/kategorier/teater/trollhattan',
    '414': 'alla-evenemang/kategorier/teater/uddevalla',
    '117': 'alla-evenemang/kategorier/teater/ostersund',
    '228': 'alla-evenemang/kategorier/teater/visby',
    '105': 'alla-evenemang/kategorier/teater/rattvik',
    '299': 'alla-evenemang/kategorier/teater/lysekil',
    '106': 'alla-evenemang/kategorier/teater/karlskrona',
    '109': 'alla-evenemang/kategorier/teater/nykoping',
    '107': 'alla-evenemang/kategorier/teater/pitea',
    '124': 'alla-evenemang/kategorier/teater/sandviken',
    '344': 'alla-evenemang/kategorier/teater/motala',
    '125': 'alla-evenemang/kategorier/teater/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/teater/soderhamn',
    '323': 'alla-evenemang/kategorier/teater/bollnas',
    '453': 'alla-evenemang/kategorier/teater/karlshamn',
    '522': 'alla-evenemang/kategorier/teater/vanersborg',
    '100': 'alla-evenemang/kategorier/teater/vadstena',
    '251': 'alla-evenemang/kategorier/teater/kungsbacka',
    '119': 'alla-evenemang/kategorier/teater/lidkoping',
    '424': 'alla-evenemang/kategorier/teater/alingsas',
    '425': 'alla-evenemang/kategorier/teater/hassleholm',
    '439': 'alla-evenemang/kategorier/teater/soderkoping',
    '130': 'alla-evenemang/kategorier/teater/stenungsund',
    '126': 'alla-evenemang/kategorier/teater/arvika',
    '102': 'alla-evenemang/kategorier/teater/borgholm',
    '362': 'alla-evenemang/kategorier/teater/jarvso',
    '111': 'alla-evenemang/kategorier/teater/furuvik',
    '122': 'alla-evenemang/kategorier/teater/huskvarna'
  },
  'alla-evenemang/kategorier/krogshow': {
    '85': 'alla-evenemang/kategorier/krogshow/goteborg',
    '24': 'alla-evenemang/kategorier/krogshow/stockholm',
    '112': 'alla-evenemang/kategorier/krogshow/malmo',
    '94': 'alla-evenemang/kategorier/krogshow/helsingborg',
    '110': 'alla-evenemang/kategorier/krogshow/orebro',
    '120': 'alla-evenemang/kategorier/krogshow/uppsala',
    '114': 'alla-evenemang/kategorier/krogshow/linkoping',
    '160': 'alla-evenemang/kategorier/krogshow/norrkoping',
    '162': 'alla-evenemang/kategorier/krogshow/vasteras',
    '108': 'alla-evenemang/kategorier/krogshow/karlstad',
    '123': 'alla-evenemang/kategorier/krogshow/jonkoping',
    '116': 'alla-evenemang/kategorier/krogshow/umea',
    '186': 'alla-evenemang/kategorier/krogshow/gavle',
    '96': 'alla-evenemang/kategorier/krogshow/sundsvall',
    '159': 'alla-evenemang/kategorier/krogshow/lulea',
    '177': 'alla-evenemang/kategorier/krogshow/falun',
    '118': 'alla-evenemang/kategorier/krogshow/eskilstuna',
    '121': 'alla-evenemang/kategorier/krogshow/kristianstad',
    '158': 'alla-evenemang/kategorier/krogshow/kalmar',
    '117': 'alla-evenemang/kategorier/krogshow/ostersund',
    '97': 'alla-evenemang/kategorier/krogshow/varberg',
    '104': 'alla-evenemang/kategorier/krogshow/halmstad',
    '437': 'alla-evenemang/kategorier/krogshow/falkenberg',
    '187': 'alla-evenemang/kategorier/krogshow/lund',
    '163': 'alla-evenemang/kategorier/krogshow/vaxjo',
    '127': 'alla-evenemang/kategorier/krogshow/boras',
    '324': 'alla-evenemang/kategorier/krogshow/trollhattan',
    '414': 'alla-evenemang/kategorier/krogshow/uddevalla',
    '228': 'alla-evenemang/kategorier/krogshow/visby',
    '221': 'alla-evenemang/kategorier/krogshow/skovde',
    '105': 'alla-evenemang/kategorier/krogshow/rattvik',
    '299': 'alla-evenemang/kategorier/krogshow/lysekil',
    '106': 'alla-evenemang/kategorier/krogshow/karlskrona',
    '109': 'alla-evenemang/kategorier/krogshow/nykoping',
    '107': 'alla-evenemang/kategorier/krogshow/pitea',
    '124': 'alla-evenemang/kategorier/krogshow/sandviken',
    '344': 'alla-evenemang/kategorier/krogshow/motala',
    '125': 'alla-evenemang/kategorier/krogshow/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/krogshow/soderhamn',
    '323': 'alla-evenemang/kategorier/krogshow/bollnas',
    '453': 'alla-evenemang/kategorier/krogshow/karlshamn',
    '522': 'alla-evenemang/kategorier/krogshow/vanersborg',
    '100': 'alla-evenemang/kategorier/krogshow/vadstena',
    '251': 'alla-evenemang/kategorier/krogshow/kungsbacka',
    '119': 'alla-evenemang/kategorier/krogshow/lidkoping',
    '424': 'alla-evenemang/kategorier/krogshow/alingsas',
    '425': 'alla-evenemang/kategorier/krogshow/hassleholm',
    '439': 'alla-evenemang/kategorier/krogshow/soderkoping',
    '130': 'alla-evenemang/kategorier/krogshow/stenungsund',
    '126': 'alla-evenemang/kategorier/krogshow/arvika',
    '102': 'alla-evenemang/kategorier/krogshow/borgholm',
    '362': 'alla-evenemang/kategorier/krogshow/jarvso',
    '111': 'alla-evenemang/kategorier/krogshow/furuvik',
    '122': 'alla-evenemang/kategorier/krogshow/huskvarna'
  },
  'alla-evenemang/kategorier/humor/stand-up': {
    '24': 'alla-evenemang/kategorier/humor/stand-up/stockholm',
    '85': 'alla-evenemang/kategorier/humor/stand-up/goteborg',
    '112': 'alla-evenemang/kategorier/humor/stand-up/malmo',
    '120': 'alla-evenemang/kategorier/humor/stand-up/uppsala',
    '123': 'alla-evenemang/kategorier/humor/stand-up/jonkoping',
    '114': 'alla-evenemang/kategorier/humor/stand-up/linkoping',
    '162': 'alla-evenemang/kategorier/humor/stand-up/vasteras',
    '160': 'alla-evenemang/kategorier/humor/stand-up/norrkoping',
    '163': 'alla-evenemang/kategorier/humor/stand-up/vaxjo',
    '94': 'alla-evenemang/kategorier/humor/stand-up/helsingborg',
    '108': 'alla-evenemang/kategorier/humor/stand-up/karlstad',
    '116': 'alla-evenemang/kategorier/humor/stand-up/umea',
    '186': 'alla-evenemang/kategorier/humor/stand-up/gavle',
    '104': 'alla-evenemang/kategorier/humor/stand-up/halmstad',
    '110': 'alla-evenemang/kategorier/humor/stand-up/orebro',
    '158': 'alla-evenemang/kategorier/humor/stand-up/kalmar',
    '221': 'alla-evenemang/kategorier/humor/stand-up/skovde',
    '127': 'alla-evenemang/kategorier/humor/stand-up/boras',
    '96': 'alla-evenemang/kategorier/humor/stand-up/sundsvall',
    '159': 'alla-evenemang/kategorier/humor/stand-up/lulea',
    '228': 'alla-evenemang/kategorier/humor/stand-up/visby',
    '118': 'alla-evenemang/kategorier/humor/stand-up/eskilstuna',
    '97': 'alla-evenemang/kategorier/humor/stand-up/varberg',
    '121': 'alla-evenemang/kategorier/humor/stand-up/kristianstad',
    '177': 'alla-evenemang/kategorier/humor/stand-up/falun',
    '117': 'alla-evenemang/kategorier/humor/stand-up/ostersund',
    '437': 'alla-evenemang/kategorier/humor/stand-up/falkenberg',
    '187': 'alla-evenemang/kategorier/humor/stand-up/lund',
    '324': 'alla-evenemang/kategorier/humor/stand-up/trollhattan',
    '414': 'alla-evenemang/kategorier/humor/stand-up/uddevalla',
    '105': 'alla-evenemang/kategorier/humor/stand-up/rattvik',
    '299': 'alla-evenemang/kategorier/humor/stand-up/lysekil',
    '106': 'alla-evenemang/kategorier/humor/stand-up/karlskrona',
    '109': 'alla-evenemang/kategorier/humor/stand-up/nykoping',
    '107': 'alla-evenemang/kategorier/humor/stand-up/pitea',
    '124': 'alla-evenemang/kategorier/humor/stand-up/sandviken',
    '344': 'alla-evenemang/kategorier/humor/stand-up/motala',
    '125': 'alla-evenemang/kategorier/humor/stand-up/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/humor/stand-up/soderhamn',
    '323': 'alla-evenemang/kategorier/humor/stand-up/bollnas',
    '453': 'alla-evenemang/kategorier/humor/stand-up/karlshamn',
    '522': 'alla-evenemang/kategorier/humor/stand-up/vanersborg',
    '100': 'alla-evenemang/kategorier/humor/stand-up/vadstena',
    '251': 'alla-evenemang/kategorier/humor/stand-up/kungsbacka',
    '119': 'alla-evenemang/kategorier/humor/stand-up/lidkoping',
    '424': 'alla-evenemang/kategorier/humor/stand-up/alingsas',
    '425': 'alla-evenemang/kategorier/humor/stand-up/hassleholm',
    '439': 'alla-evenemang/kategorier/humor/stand-up/soderkoping',
    '130': 'alla-evenemang/kategorier/humor/stand-up/stenungsund',
    '126': 'alla-evenemang/kategorier/humor/stand-up/arvika',
    '102': 'alla-evenemang/kategorier/humor/stand-up/borgholm',
    '362': 'alla-evenemang/kategorier/humor/stand-up/jarvso',
    '111': 'alla-evenemang/kategorier/humor/stand-up/furuvik',
    '122': 'alla-evenemang/kategorier/humor/stand-up/huskvarna'
  },
  'alla-evenemang/kategorier/teater/musikal': {
    '24': 'alla-evenemang/kategorier/teater/musikal/stockholm',
    '85': 'alla-evenemang/kategorier/teater/musikal/goteborg',
    '112': 'alla-evenemang/kategorier/teater/musikal/malmo',
    '104': 'alla-evenemang/kategorier/teater/musikal/halmstad',
    '120': 'alla-evenemang/kategorier/teater/musikal/uppsala',
    '108': 'alla-evenemang/kategorier/teater/musikal/karlstad',
    '114': 'alla-evenemang/kategorier/teater/musikal/linkoping',
    '94': 'alla-evenemang/kategorier/teater/musikal/helsingborg',
    '163': 'alla-evenemang/kategorier/teater/musikal/vaxjo',
    '123': 'alla-evenemang/kategorier/teater/musikal/jonkoping',
    '160': 'alla-evenemang/kategorier/teater/musikal/norrkoping',
    '110': 'alla-evenemang/kategorier/teater/musikal/orebro',
    '116': 'alla-evenemang/kategorier/teater/musikal/umea',
    '96': 'alla-evenemang/kategorier/teater/musikal/sundsvall',
    '162': 'alla-evenemang/kategorier/teater/musikal/vasteras',
    '159': 'alla-evenemang/kategorier/teater/musikal/lulea',
    '187': 'alla-evenemang/kategorier/teater/musikal/lund',
    '324': 'alla-evenemang/kategorier/teater/musikal/trollhattan',
    '186': 'alla-evenemang/kategorier/teater/musikal/gavle',
    '177': 'alla-evenemang/kategorier/teater/musikal/falun',
    '118': 'alla-evenemang/kategorier/teater/musikal/eskilstuna',
    '437': 'alla-evenemang/kategorier/teater/musikal/falkenberg',
    '127': 'alla-evenemang/kategorier/teater/musikal/boras',
    '121': 'alla-evenemang/kategorier/teater/musikal/kristianstad',
    '158': 'alla-evenemang/kategorier/teater/musikal/kalmar',
    '117': 'alla-evenemang/kategorier/teater/musikal/ostersund',
    '97': 'alla-evenemang/kategorier/teater/musikal/varberg',
    '414': 'alla-evenemang/kategorier/teater/musikal/uddevalla',
    '228': 'alla-evenemang/kategorier/teater/musikal/visby',
    '221': 'alla-evenemang/kategorier/teater/musikal/skovde',
    '105': 'alla-evenemang/kategorier/teater/musikal/rattvik',
    '299': 'alla-evenemang/kategorier/teater/musikal/lysekil',
    '106': 'alla-evenemang/kategorier/teater/musikal/karlskrona',
    '109': 'alla-evenemang/kategorier/teater/musikal/nykoping',
    '107': 'alla-evenemang/kategorier/teater/musikal/pitea',
    '124': 'alla-evenemang/kategorier/teater/musikal/sandviken',
    '344': 'alla-evenemang/kategorier/teater/musikal/motala',
    '125': 'alla-evenemang/kategorier/teater/musikal/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/teater/musikal/soderhamn',
    '323': 'alla-evenemang/kategorier/teater/musikal/bollnas',
    '453': 'alla-evenemang/kategorier/teater/musikal/karlshamn',
    '522': 'alla-evenemang/kategorier/teater/musikal/vanersborg',
    '100': 'alla-evenemang/kategorier/teater/musikal/vadstena',
    '251': 'alla-evenemang/kategorier/teater/musikal/kungsbacka',
    '119': 'alla-evenemang/kategorier/teater/musikal/lidkoping',
    '424': 'alla-evenemang/kategorier/teater/musikal/alingsas',
    '425': 'alla-evenemang/kategorier/teater/musikal/hassleholm',
    '439': 'alla-evenemang/kategorier/teater/musikal/soderkoping',
    '130': 'alla-evenemang/kategorier/teater/musikal/stenungsund',
    '126': 'alla-evenemang/kategorier/teater/musikal/arvika',
    '102': 'alla-evenemang/kategorier/teater/musikal/borgholm',
    '362': 'alla-evenemang/kategorier/teater/musikal/jarvso',
    '111': 'alla-evenemang/kategorier/teater/musikal/furuvik',
    '122': 'alla-evenemang/kategorier/teater/musikal/huskvarna'
  },
  'alla-evenemang/kategorier/konsert/pop': {
    '24': 'alla-evenemang/kategorier/konsert/pop/stockholm',
    '112': 'alla-evenemang/kategorier/konsert/pop/malmo',
    '110': 'alla-evenemang/kategorier/konsert/pop/orebro',
    '85': 'alla-evenemang/kategorier/konsert/pop/goteborg',
    '120': 'alla-evenemang/kategorier/konsert/pop/uppsala',
    '114': 'alla-evenemang/kategorier/konsert/pop/linkoping',
    '94': 'alla-evenemang/kategorier/konsert/pop/helsingborg',
    '160': 'alla-evenemang/kategorier/konsert/pop/norrkoping',
    '162': 'alla-evenemang/kategorier/konsert/pop/vasteras',
    '108': 'alla-evenemang/kategorier/konsert/pop/karlstad',
    '123': 'alla-evenemang/kategorier/konsert/pop/jonkoping',
    '116': 'alla-evenemang/kategorier/konsert/pop/umea',
    '186': 'alla-evenemang/kategorier/konsert/pop/gavle',
    '96': 'alla-evenemang/kategorier/konsert/pop/sundsvall',
    '159': 'alla-evenemang/kategorier/konsert/pop/lulea',
    '177': 'alla-evenemang/kategorier/konsert/pop/falun',
    '118': 'alla-evenemang/kategorier/konsert/pop/eskilstuna',
    '121': 'alla-evenemang/kategorier/konsert/pop/kristianstad',
    '158': 'alla-evenemang/kategorier/konsert/pop/kalmar',
    '117': 'alla-evenemang/kategorier/konsert/pop/ostersund',
    '97': 'alla-evenemang/kategorier/konsert/pop/varberg',
    '104': 'alla-evenemang/kategorier/konsert/pop/halmstad',
    '437': 'alla-evenemang/kategorier/konsert/pop/falkenberg',
    '187': 'alla-evenemang/kategorier/konsert/pop/lund',
    '163': 'alla-evenemang/kategorier/konsert/pop/vaxjo',
    '127': 'alla-evenemang/kategorier/konsert/pop/boras',
    '324': 'alla-evenemang/kategorier/konsert/pop/trollhattan',
    '414': 'alla-evenemang/kategorier/konsert/pop/uddevalla',
    '228': 'alla-evenemang/kategorier/konsert/pop/visby',
    '221': 'alla-evenemang/kategorier/konsert/pop/skovde',
    '105': 'alla-evenemang/kategorier/konsert/pop/rattvik',
    '299': 'alla-evenemang/kategorier/konsert/pop/lysekil',
    '106': 'alla-evenemang/kategorier/konsert/pop/karlskrona',
    '109': 'alla-evenemang/kategorier/konsert/pop/nykoping',
    '107': 'alla-evenemang/kategorier/konsert/pop/pitea',
    '124': 'alla-evenemang/kategorier/konsert/pop/sandviken',
    '344': 'alla-evenemang/kategorier/konsert/pop/motala',
    '125': 'alla-evenemang/kategorier/konsert/pop/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/konsert/pop/soderhamn',
    '323': 'alla-evenemang/kategorier/konsert/pop/bollnas',
    '453': 'alla-evenemang/kategorier/konsert/pop/karlshamn',
    '522': 'alla-evenemang/kategorier/konsert/pop/vanersborg',
    '100': 'alla-evenemang/kategorier/konsert/pop/vadstena',
    '251': 'alla-evenemang/kategorier/konsert/pop/kungsbacka',
    '119': 'alla-evenemang/kategorier/konsert/pop/lidkoping',
    '424': 'alla-evenemang/kategorier/konsert/pop/alingsas',
    '425': 'alla-evenemang/kategorier/konsert/pop/hassleholm',
    '439': 'alla-evenemang/kategorier/konsert/pop/soderkoping',
    '130': 'alla-evenemang/kategorier/konsert/pop/stenungsund',
    '126': 'alla-evenemang/kategorier/konsert/pop/arvika',
    '102': 'alla-evenemang/kategorier/konsert/pop/borgholm',
    '362': 'alla-evenemang/kategorier/konsert/pop/jarvso',
    '111': 'alla-evenemang/kategorier/konsert/pop/furuvik',
    '122': 'alla-evenemang/kategorier/konsert/pop/huskvarna'
  },
  'alla-evenemang/kategorier/konsert/dansband': {
    '85': 'alla-evenemang/kategorier/konsert/dansband/goteborg',
    '24': 'alla-evenemang/kategorier/konsert/dansband/stockholm',
    '112': 'alla-evenemang/kategorier/konsert/dansband/malmo',
    '94': 'alla-evenemang/kategorier/konsert/dansband/helsingborg',
    '114': 'alla-evenemang/kategorier/konsert/dansband/linkoping',
    '110': 'alla-evenemang/kategorier/konsert/dansband/orebro',
    '120': 'alla-evenemang/kategorier/konsert/dansband/uppsala',
    '160': 'alla-evenemang/kategorier/konsert/dansband/norrkoping',
    '162': 'alla-evenemang/kategorier/konsert/dansband/vasteras',
    '108': 'alla-evenemang/kategorier/konsert/dansband/karlstad',
    '123': 'alla-evenemang/kategorier/konsert/dansband/jonkoping',
    '116': 'alla-evenemang/kategorier/konsert/dansband/umea',
    '186': 'alla-evenemang/kategorier/konsert/dansband/gavle',
    '96': 'alla-evenemang/kategorier/konsert/dansband/sundsvall',
    '159': 'alla-evenemang/kategorier/konsert/dansband/lulea',
    '177': 'alla-evenemang/kategorier/konsert/dansband/falun',
    '118': 'alla-evenemang/kategorier/konsert/dansband/eskilstuna',
    '121': 'alla-evenemang/kategorier/konsert/dansband/kristianstad',
    '158': 'alla-evenemang/kategorier/konsert/dansband/kalmar',
    '117': 'alla-evenemang/kategorier/konsert/dansband/ostersund',
    '97': 'alla-evenemang/kategorier/konsert/dansband/varberg',
    '104': 'alla-evenemang/kategorier/konsert/dansband/halmstad',
    '437': 'alla-evenemang/kategorier/konsert/dansband/falkenberg',
    '187': 'alla-evenemang/kategorier/konsert/dansband/lund',
    '163': 'alla-evenemang/kategorier/konsert/dansband/vaxjo',
    '127': 'alla-evenemang/kategorier/konsert/dansband/boras',
    '324': 'alla-evenemang/kategorier/konsert/dansband/trollhattan',
    '414': 'alla-evenemang/kategorier/konsert/dansband/uddevalla',
    '228': 'alla-evenemang/kategorier/konsert/dansband/visby',
    '221': 'alla-evenemang/kategorier/konsert/dansband/skovde',
    '105': 'alla-evenemang/kategorier/konsert/dansband/rattvik',
    '299': 'alla-evenemang/kategorier/konsert/dansband/lysekil',
    '106': 'alla-evenemang/kategorier/konsert/dansband/karlskrona',
    '109': 'alla-evenemang/kategorier/konsert/dansband/nykoping',
    '107': 'alla-evenemang/kategorier/konsert/dansband/pitea',
    '124': 'alla-evenemang/kategorier/konsert/dansband/sandviken',
    '344': 'alla-evenemang/kategorier/konsert/dansband/motala',
    '125': 'alla-evenemang/kategorier/konsert/dansband/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/konsert/dansband/soderhamn',
    '323': 'alla-evenemang/kategorier/konsert/dansband/bollnas',
    '453': 'alla-evenemang/kategorier/konsert/dansband/karlshamn',
    '522': 'alla-evenemang/kategorier/konsert/dansband/vanersborg',
    '100': 'alla-evenemang/kategorier/konsert/dansband/vadstena',
    '251': 'alla-evenemang/kategorier/konsert/dansband/kungsbacka',
    '119': 'alla-evenemang/kategorier/konsert/dansband/lidkoping',
    '424': 'alla-evenemang/kategorier/konsert/dansband/alingsas',
    '425': 'alla-evenemang/kategorier/konsert/dansband/hassleholm',
    '439': 'alla-evenemang/kategorier/konsert/dansband/soderkoping',
    '130': 'alla-evenemang/kategorier/konsert/dansband/stenungsund',
    '126': 'alla-evenemang/kategorier/konsert/dansband/arvika',
    '102': 'alla-evenemang/kategorier/konsert/dansband/borgholm',
    '362': 'alla-evenemang/kategorier/konsert/dansband/jarvso',
    '111': 'alla-evenemang/kategorier/konsert/dansband/furuvik',
    '122': 'alla-evenemang/kategorier/konsert/dansband/huskvarna'
  },
  'alla-evenemang/kategorier/konsert/hardrock-metal': {
    '24': 'alla-evenemang/kategorier/konsert/hardrock-metal/stockholm',
    '85': 'alla-evenemang/kategorier/konsert/hardrock-metal/goteborg',
    '112': 'alla-evenemang/kategorier/konsert/hardrock-metal/malmo',
    '120': 'alla-evenemang/kategorier/konsert/hardrock-metal/uppsala',
    '110': 'alla-evenemang/kategorier/konsert/hardrock-metal/orebro',
    '114': 'alla-evenemang/kategorier/konsert/hardrock-metal/linkoping',
    '94': 'alla-evenemang/kategorier/konsert/hardrock-metal/helsingborg',
    '160': 'alla-evenemang/kategorier/konsert/hardrock-metal/norrkoping',
    '162': 'alla-evenemang/kategorier/konsert/hardrock-metal/vasteras',
    '108': 'alla-evenemang/kategorier/konsert/hardrock-metal/karlstad',
    '123': 'alla-evenemang/kategorier/konsert/hardrock-metal/jonkoping',
    '116': 'alla-evenemang/kategorier/konsert/hardrock-metal/umea',
    '186': 'alla-evenemang/kategorier/konsert/hardrock-metal/gavle',
    '96': 'alla-evenemang/kategorier/konsert/hardrock-metal/sundsvall',
    '159': 'alla-evenemang/kategorier/konsert/hardrock-metal/lulea',
    '177': 'alla-evenemang/kategorier/konsert/hardrock-metal/falun',
    '118': 'alla-evenemang/kategorier/konsert/hardrock-metal/eskilstuna',
    '121': 'alla-evenemang/kategorier/konsert/hardrock-metal/kristianstad',
    '158': 'alla-evenemang/kategorier/konsert/hardrock-metal/kalmar',
    '117': 'alla-evenemang/kategorier/konsert/hardrock-metal/ostersund',
    '97': 'alla-evenemang/kategorier/konsert/hardrock-metal/varberg',
    '104': 'alla-evenemang/kategorier/konsert/hardrock-metal/halmstad',
    '437': 'alla-evenemang/kategorier/konsert/hardrock-metal/falkenberg',
    '187': 'alla-evenemang/kategorier/konsert/hardrock-metal/lund',
    '163': 'alla-evenemang/kategorier/konsert/hardrock-metal/vaxjo',
    '127': 'alla-evenemang/kategorier/konsert/hardrock-metal/boras',
    '324': 'alla-evenemang/kategorier/konsert/hardrock-metal/trollhattan',
    '414': 'alla-evenemang/kategorier/konsert/hardrock-metal/uddevalla',
    '228': 'alla-evenemang/kategorier/konsert/hardrock-metal/visby',
    '221': 'alla-evenemang/kategorier/konsert/hardrock-metal/skovde',
    '105': 'alla-evenemang/kategorier/konsert/hardrock-metal/rattvik',
    '299': 'alla-evenemang/kategorier/konsert/hardrock-metal/lysekil',
    '106': 'alla-evenemang/kategorier/konsert/hardrock-metal/karlskrona',
    '109': 'alla-evenemang/kategorier/konsert/hardrock-metal/nykoping',
    '107': 'alla-evenemang/kategorier/konsert/hardrock-metal/pitea',
    '124': 'alla-evenemang/kategorier/konsert/hardrock-metal/sandviken',
    '344': 'alla-evenemang/kategorier/konsert/hardrock-metal/motala',
    '125': 'alla-evenemang/kategorier/konsert/hardrock-metal/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/konsert/hardrock-metal/soderhamn',
    '323': 'alla-evenemang/kategorier/konsert/hardrock-metal/bollnas',
    '453': 'alla-evenemang/kategorier/konsert/hardrock-metal/karlshamn',
    '522': 'alla-evenemang/kategorier/konsert/hardrock-metal/vanersborg',
    '100': 'alla-evenemang/kategorier/konsert/hardrock-metal/vadstena',
    '251': 'alla-evenemang/kategorier/konsert/hardrock-metal/kungsbacka',
    '119': 'alla-evenemang/kategorier/konsert/hardrock-metal/lidkoping',
    '424': 'alla-evenemang/kategorier/konsert/hardrock-metal/alingsas',
    '425': 'alla-evenemang/kategorier/konsert/hardrock-metal/hassleholm',
    '439': 'alla-evenemang/kategorier/konsert/hardrock-metal/soderkoping',
    '130': 'alla-evenemang/kategorier/konsert/hardrock-metal/stenungsund',
    '126': 'alla-evenemang/kategorier/konsert/hardrock-metal/arvika',
    '102': 'alla-evenemang/kategorier/konsert/hardrock-metal/borgholm',
    '362': 'alla-evenemang/kategorier/konsert/hardrock-metal/jarvso',
    '111': 'alla-evenemang/kategorier/konsert/hardrock-metal/furuvik',
    '122': 'alla-evenemang/kategorier/konsert/hardrock-metal/huskvarna'
  },
  'alla-evenemang/kategorier/teater/revy': {
    '24': 'alla-evenemang/kategorier/teater/revy/stockholm',
    '85': 'alla-evenemang/kategorier/teater/revy/goteborg',
    '114': 'alla-evenemang/kategorier/teater/revy/linkoping',
    '112': 'alla-evenemang/kategorier/teater/revy/malmo',
    '110': 'alla-evenemang/kategorier/teater/revy/orebro',
    '94': 'alla-evenemang/kategorier/teater/revy/helsingborg',
    '120': 'alla-evenemang/kategorier/teater/revy/uppsala',
    '160': 'alla-evenemang/kategorier/teater/revy/norrkoping',
    '162': 'alla-evenemang/kategorier/teater/revy/vasteras',
    '108': 'alla-evenemang/kategorier/teater/revy/karlstad',
    '123': 'alla-evenemang/kategorier/teater/revy/jonkoping',
    '116': 'alla-evenemang/kategorier/teater/revy/umea',
    '186': 'alla-evenemang/kategorier/teater/revy/gavle',
    '96': 'alla-evenemang/kategorier/teater/revy/sundsvall',
    '159': 'alla-evenemang/kategorier/teater/revy/lulea',
    '177': 'alla-evenemang/kategorier/teater/revy/falun',
    '118': 'alla-evenemang/kategorier/teater/revy/eskilstuna',
    '121': 'alla-evenemang/kategorier/teater/revy/kristianstad',
    '158': 'alla-evenemang/kategorier/teater/revy/kalmar',
    '117': 'alla-evenemang/kategorier/teater/revy/ostersund',
    '97': 'alla-evenemang/kategorier/teater/revy/varberg',
    '104': 'alla-evenemang/kategorier/teater/revy/halmstad',
    '437': 'alla-evenemang/kategorier/teater/revy/falkenberg',
    '187': 'alla-evenemang/kategorier/teater/revy/lund',
    '163': 'alla-evenemang/kategorier/teater/revy/vaxjo',
    '127': 'alla-evenemang/kategorier/teater/revy/boras',
    '324': 'alla-evenemang/kategorier/teater/revy/trollhattan',
    '414': 'alla-evenemang/kategorier/teater/revy/uddevalla',
    '228': 'alla-evenemang/kategorier/teater/revy/visby',
    '221': 'alla-evenemang/kategorier/teater/revy/skovde',
    '105': 'alla-evenemang/kategorier/teater/revy/rattvik',
    '299': 'alla-evenemang/kategorier/teater/revy/lysekil',
    '106': 'alla-evenemang/kategorier/teater/revy/karlskrona',
    '109': 'alla-evenemang/kategorier/teater/revy/nykoping',
    '107': 'alla-evenemang/kategorier/teater/revy/pitea',
    '124': 'alla-evenemang/kategorier/teater/revy/sandviken',
    '344': 'alla-evenemang/kategorier/teater/revy/motala',
    '125': 'alla-evenemang/kategorier/teater/revy/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/teater/revy/soderhamn',
    '323': 'alla-evenemang/kategorier/teater/revy/bollnas',
    '453': 'alla-evenemang/kategorier/teater/revy/karlshamn',
    '522': 'alla-evenemang/kategorier/teater/revy/vanersborg',
    '100': 'alla-evenemang/kategorier/teater/revy/vadstena',
    '251': 'alla-evenemang/kategorier/teater/revy/kungsbacka',
    '119': 'alla-evenemang/kategorier/teater/revy/lidkoping',
    '424': 'alla-evenemang/kategorier/teater/revy/alingsas',
    '425': 'alla-evenemang/kategorier/teater/revy/hassleholm',
    '439': 'alla-evenemang/kategorier/teater/revy/soderkoping',
    '130': 'alla-evenemang/kategorier/teater/revy/stenungsund',
    '126': 'alla-evenemang/kategorier/teater/revy/arvika',
    '102': 'alla-evenemang/kategorier/teater/revy/borgholm',
    '362': 'alla-evenemang/kategorier/teater/revy/jarvso',
    '111': 'alla-evenemang/kategorier/teater/revy/furuvik',
    '122': 'alla-evenemang/kategorier/teater/revy/huskvarna'
  },
  'alla-evenemang/kategorier/konsert/julkonsert': {
    '24': 'alla-evenemang/kategorier/konsert/julkonsert/stockholm',
    '85': 'alla-evenemang/kategorier/konsert/julkonsert/goteborg',
    '110': 'alla-evenemang/kategorier/konsert/julkonsert/orebro',
    '120': 'alla-evenemang/kategorier/konsert/julkonsert/uppsala',
    '94': 'alla-evenemang/kategorier/konsert/julkonsert/helsingborg',
    '160': 'alla-evenemang/kategorier/konsert/julkonsert/norrkoping',
    '112': 'alla-evenemang/kategorier/konsert/julkonsert/malmo',
    '114': 'alla-evenemang/kategorier/konsert/julkonsert/linkoping',
    '162': 'alla-evenemang/kategorier/konsert/julkonsert/vasteras',
    '108': 'alla-evenemang/kategorier/konsert/julkonsert/karlstad',
    '123': 'alla-evenemang/kategorier/konsert/julkonsert/jonkoping',
    '116': 'alla-evenemang/kategorier/konsert/julkonsert/umea',
    '186': 'alla-evenemang/kategorier/konsert/julkonsert/gavle',
    '96': 'alla-evenemang/kategorier/konsert/julkonsert/sundsvall',
    '159': 'alla-evenemang/kategorier/konsert/julkonsert/lulea',
    '177': 'alla-evenemang/kategorier/konsert/julkonsert/falun',
    '118': 'alla-evenemang/kategorier/konsert/julkonsert/eskilstuna',
    '121': 'alla-evenemang/kategorier/konsert/julkonsert/kristianstad',
    '158': 'alla-evenemang/kategorier/konsert/julkonsert/kalmar',
    '117': 'alla-evenemang/kategorier/konsert/julkonsert/ostersund',
    '97': 'alla-evenemang/kategorier/konsert/julkonsert/varberg',
    '104': 'alla-evenemang/kategorier/konsert/julkonsert/halmstad',
    '437': 'alla-evenemang/kategorier/konsert/julkonsert/falkenberg',
    '187': 'alla-evenemang/kategorier/konsert/julkonsert/lund',
    '163': 'alla-evenemang/kategorier/konsert/julkonsert/vaxjo',
    '127': 'alla-evenemang/kategorier/konsert/julkonsert/boras',
    '324': 'alla-evenemang/kategorier/konsert/julkonsert/trollhattan',
    '414': 'alla-evenemang/kategorier/konsert/julkonsert/uddevalla',
    '228': 'alla-evenemang/kategorier/konsert/julkonsert/visby',
    '221': 'alla-evenemang/kategorier/konsert/julkonsert/skovde',
    '105': 'alla-evenemang/kategorier/konsert/julkonsert/rattvik',
    '299': 'alla-evenemang/kategorier/konsert/julkonsert/lysekil',
    '106': 'alla-evenemang/kategorier/konsert/julkonsert/karlskrona',
    '109': 'alla-evenemang/kategorier/konsert/julkonsert/nykoping',
    '107': 'alla-evenemang/kategorier/konsert/julkonsert/pitea',
    '124': 'alla-evenemang/kategorier/konsert/julkonsert/sandviken',
    '344': 'alla-evenemang/kategorier/konsert/julkonsert/motala',
    '125': 'alla-evenemang/kategorier/konsert/julkonsert/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/konsert/julkonsert/soderhamn',
    '323': 'alla-evenemang/kategorier/konsert/julkonsert/bollnas',
    '453': 'alla-evenemang/kategorier/konsert/julkonsert/karlshamn',
    '522': 'alla-evenemang/kategorier/konsert/julkonsert/vanersborg',
    '100': 'alla-evenemang/kategorier/konsert/julkonsert/vadstena',
    '251': 'alla-evenemang/kategorier/konsert/julkonsert/kungsbacka',
    '119': 'alla-evenemang/kategorier/konsert/julkonsert/lidkoping',
    '424': 'alla-evenemang/kategorier/konsert/julkonsert/alingsas',
    '425': 'alla-evenemang/kategorier/konsert/julkonsert/hassleholm',
    '439': 'alla-evenemang/kategorier/konsert/julkonsert/soderkoping',
    '130': 'alla-evenemang/kategorier/konsert/julkonsert/stenungsund',
    '126': 'alla-evenemang/kategorier/konsert/julkonsert/arvika',
    '102': 'alla-evenemang/kategorier/konsert/julkonsert/borgholm',
    '362': 'alla-evenemang/kategorier/konsert/julkonsert/jarvso',
    '111': 'alla-evenemang/kategorier/konsert/julkonsert/furuvik',
    '122': 'alla-evenemang/kategorier/konsert/julkonsert/huskvarna'
  },
  'alla-evenemang/kategorier/konsert/hip-hop-rnb': {
    '24': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/stockholm',
    '85': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/goteborg',
    '112': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/malmo',
    '110': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/orebro',
    '120': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/uppsala',
    '114': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/linkoping',
    '94': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/helsingborg',
    '160': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/norrkoping',
    '162': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/vasteras',
    '108': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/karlstad',
    '123': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/jonkoping',
    '116': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/umea',
    '186': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/gavle',
    '96': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/sundsvall',
    '159': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/lulea',
    '177': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/falun',
    '118': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/eskilstuna',
    '121': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/kristianstad',
    '158': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/kalmar',
    '117': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/ostersund',
    '97': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/varberg',
    '104': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/halmstad',
    '437': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/falkenberg',
    '187': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/lund',
    '163': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/vaxjo',
    '127': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/boras',
    '324': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/trollhattan',
    '414': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/uddevalla',
    '228': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/visby',
    '221': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/skovde',
    '105': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/rattvik',
    '299': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/lysekil',
    '106': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/karlskrona',
    '109': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/nykoping',
    '107': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/pitea',
    '124': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/sandviken',
    '344': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/motala',
    '125': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/soderhamn',
    '323': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/bollnas',
    '453': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/karlshamn',
    '522': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/vanersborg',
    '100': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/vadstena',
    '251': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/kungsbacka',
    '119': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/lidkoping',
    '424': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/alingsas',
    '425': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/hassleholm',
    '439': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/soderkoping',
    '130': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/stenungsund',
    '126': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/arvika',
    '102': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/borgholm',
    '362': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/jarvso',
    '111': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/furuvik',
    '122': 'alla-evenemang/kategorier/konsert/hip-hop-rnb/huskvarna'
  },
  'alla-evenemang/kategorier/konsert/klassisk-musik': {
    '24': 'alla-evenemang/kategorier/konsert/klassisk-musik/stockholm',
    '85': 'alla-evenemang/kategorier/konsert/klassisk-musik/goteborg',
    '112': 'alla-evenemang/kategorier/konsert/klassisk-musik/malmo',
    '120': 'alla-evenemang/kategorier/konsert/klassisk-musik/uppsala',
    '110': 'alla-evenemang/kategorier/konsert/klassisk-musik/orebro',
    '114': 'alla-evenemang/kategorier/konsert/klassisk-musik/linkoping',
    '94': 'alla-evenemang/kategorier/konsert/klassisk-musik/helsingborg',
    '160': 'alla-evenemang/kategorier/konsert/klassisk-musik/norrkoping',
    '162': 'alla-evenemang/kategorier/konsert/klassisk-musik/vasteras',
    '108': 'alla-evenemang/kategorier/konsert/klassisk-musik/karlstad',
    '123': 'alla-evenemang/kategorier/konsert/klassisk-musik/jonkoping',
    '116': 'alla-evenemang/kategorier/konsert/klassisk-musik/umea',
    '186': 'alla-evenemang/kategorier/konsert/klassisk-musik/gavle',
    '96': 'alla-evenemang/kategorier/konsert/klassisk-musik/sundsvall',
    '159': 'alla-evenemang/kategorier/konsert/klassisk-musik/lulea',
    '177': 'alla-evenemang/kategorier/konsert/klassisk-musik/falun',
    '118': 'alla-evenemang/kategorier/konsert/klassisk-musik/eskilstuna',
    '121': 'alla-evenemang/kategorier/konsert/klassisk-musik/kristianstad',
    '158': 'alla-evenemang/kategorier/konsert/klassisk-musik/kalmar',
    '117': 'alla-evenemang/kategorier/konsert/klassisk-musik/ostersund',
    '97': 'alla-evenemang/kategorier/konsert/klassisk-musik/varberg',
    '104': 'alla-evenemang/kategorier/konsert/klassisk-musik/halmstad',
    '437': 'alla-evenemang/kategorier/konsert/klassisk-musik/falkenberg',
    '187': 'alla-evenemang/kategorier/konsert/klassisk-musik/lund',
    '163': 'alla-evenemang/kategorier/konsert/klassisk-musik/vaxjo',
    '127': 'alla-evenemang/kategorier/konsert/klassisk-musik/boras',
    '324': 'alla-evenemang/kategorier/konsert/klassisk-musik/trollhattan',
    '414': 'alla-evenemang/kategorier/konsert/klassisk-musik/uddevalla',
    '228': 'alla-evenemang/kategorier/konsert/klassisk-musik/visby',
    '221': 'alla-evenemang/kategorier/konsert/klassisk-musik/skovde',
    '105': 'alla-evenemang/kategorier/konsert/klassisk-musik/rattvik',
    '299': 'alla-evenemang/kategorier/konsert/klassisk-musik/lysekil',
    '106': 'alla-evenemang/kategorier/konsert/klassisk-musik/karlskrona',
    '109': 'alla-evenemang/kategorier/konsert/klassisk-musik/nykoping',
    '107': 'alla-evenemang/kategorier/konsert/klassisk-musik/pitea',
    '124': 'alla-evenemang/kategorier/konsert/klassisk-musik/sandviken',
    '344': 'alla-evenemang/kategorier/konsert/klassisk-musik/motala',
    '125': 'alla-evenemang/kategorier/konsert/klassisk-musik/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/konsert/klassisk-musik/soderhamn',
    '323': 'alla-evenemang/kategorier/konsert/klassisk-musik/bollnas',
    '453': 'alla-evenemang/kategorier/konsert/klassisk-musik/karlshamn',
    '522': 'alla-evenemang/kategorier/konsert/klassisk-musik/vanersborg',
    '100': 'alla-evenemang/kategorier/konsert/klassisk-musik/vadstena',
    '251': 'alla-evenemang/kategorier/konsert/klassisk-musik/kungsbacka',
    '119': 'alla-evenemang/kategorier/konsert/klassisk-musik/lidkoping',
    '424': 'alla-evenemang/kategorier/konsert/klassisk-musik/alingsas',
    '425': 'alla-evenemang/kategorier/konsert/klassisk-musik/hassleholm',
    '439': 'alla-evenemang/kategorier/konsert/klassisk-musik/soderkoping',
    '130': 'alla-evenemang/kategorier/konsert/klassisk-musik/stenungsund',
    '126': 'alla-evenemang/kategorier/konsert/klassisk-musik/arvika',
    '102': 'alla-evenemang/kategorier/konsert/klassisk-musik/borgholm',
    '362': 'alla-evenemang/kategorier/konsert/klassisk-musik/jarvso',
    '111': 'alla-evenemang/kategorier/konsert/klassisk-musik/furuvik',
    '122': 'alla-evenemang/kategorier/konsert/klassisk-musik/huskvarna'
  },
  'alla-evenemang/kategorier/konsert/rock': {
    '24': 'alla-evenemang/kategorier/konsert/rock/stockholm',
    '85': 'alla-evenemang/kategorier/konsert/rock/goteborg',
    '94': 'alla-evenemang/kategorier/konsert/rock/helsingborg',
    '110': 'alla-evenemang/kategorier/konsert/rock/orebro',
    '114': 'alla-evenemang/kategorier/konsert/rock/linkoping',
    '112': 'alla-evenemang/kategorier/konsert/rock/malmo',
    '120': 'alla-evenemang/kategorier/konsert/rock/uppsala',
    '160': 'alla-evenemang/kategorier/konsert/rock/norrkoping',
    '162': 'alla-evenemang/kategorier/konsert/rock/vasteras',
    '108': 'alla-evenemang/kategorier/konsert/rock/karlstad',
    '123': 'alla-evenemang/kategorier/konsert/rock/jonkoping',
    '116': 'alla-evenemang/kategorier/konsert/rock/umea',
    '186': 'alla-evenemang/kategorier/konsert/rock/gavle',
    '96': 'alla-evenemang/kategorier/konsert/rock/sundsvall',
    '159': 'alla-evenemang/kategorier/konsert/rock/lulea',
    '177': 'alla-evenemang/kategorier/konsert/rock/falun',
    '118': 'alla-evenemang/kategorier/konsert/rock/eskilstuna',
    '121': 'alla-evenemang/kategorier/konsert/rock/kristianstad',
    '158': 'alla-evenemang/kategorier/konsert/rock/kalmar',
    '117': 'alla-evenemang/kategorier/konsert/rock/ostersund',
    '97': 'alla-evenemang/kategorier/konsert/rock/varberg',
    '104': 'alla-evenemang/kategorier/konsert/rock/halmstad',
    '437': 'alla-evenemang/kategorier/konsert/rock/falkenberg',
    '187': 'alla-evenemang/kategorier/konsert/rock/lund',
    '163': 'alla-evenemang/kategorier/konsert/rock/vaxjo',
    '127': 'alla-evenemang/kategorier/konsert/rock/boras',
    '324': 'alla-evenemang/kategorier/konsert/rock/trollhattan',
    '414': 'alla-evenemang/kategorier/konsert/rock/uddevalla',
    '228': 'alla-evenemang/kategorier/konsert/rock/visby',
    '221': 'alla-evenemang/kategorier/konsert/rock/skovde',
    '105': 'alla-evenemang/kategorier/konsert/rock/rattvik',
    '299': 'alla-evenemang/kategorier/konsert/rock/lysekil',
    '106': 'alla-evenemang/kategorier/konsert/rock/karlskrona',
    '109': 'alla-evenemang/kategorier/konsert/rock/nykoping',
    '107': 'alla-evenemang/kategorier/konsert/rock/pitea',
    '124': 'alla-evenemang/kategorier/konsert/rock/sandviken',
    '344': 'alla-evenemang/kategorier/konsert/rock/motala',
    '125': 'alla-evenemang/kategorier/konsert/rock/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/konsert/rock/soderhamn',
    '323': 'alla-evenemang/kategorier/konsert/rock/bollnas',
    '453': 'alla-evenemang/kategorier/konsert/rock/karlshamn',
    '522': 'alla-evenemang/kategorier/konsert/rock/vanersborg',
    '100': 'alla-evenemang/kategorier/konsert/rock/vadstena',
    '251': 'alla-evenemang/kategorier/konsert/rock/kungsbacka',
    '119': 'alla-evenemang/kategorier/konsert/rock/lidkoping',
    '424': 'alla-evenemang/kategorier/konsert/rock/alingsas',
    '425': 'alla-evenemang/kategorier/konsert/rock/hassleholm',
    '439': 'alla-evenemang/kategorier/konsert/rock/soderkoping',
    '130': 'alla-evenemang/kategorier/konsert/rock/stenungsund',
    '126': 'alla-evenemang/kategorier/konsert/rock/arvika',
    '102': 'alla-evenemang/kategorier/konsert/rock/borgholm',
    '362': 'alla-evenemang/kategorier/konsert/rock/jarvso',
    '111': 'alla-evenemang/kategorier/konsert/rock/furuvik',
    '122': 'alla-evenemang/kategorier/konsert/rock/huskvarna'
  },
  'alla-evenemang/kategorier/konsert/country': {
    '85': 'alla-evenemang/kategorier/konsert/country/goteborg',
    '24': 'alla-evenemang/kategorier/konsert/country/stockholm',
    '120': 'alla-evenemang/kategorier/konsert/country/uppsala',
    '112': 'alla-evenemang/kategorier/konsert/country/malmo',
    '110': 'alla-evenemang/kategorier/konsert/country/orebro',
    '114': 'alla-evenemang/kategorier/konsert/country/linkoping',
    '94': 'alla-evenemang/kategorier/konsert/country/helsingborg',
    '160': 'alla-evenemang/kategorier/konsert/country/norrkoping',
    '162': 'alla-evenemang/kategorier/konsert/country/vasteras',
    '108': 'alla-evenemang/kategorier/konsert/country/karlstad',
    '123': 'alla-evenemang/kategorier/konsert/country/jonkoping',
    '116': 'alla-evenemang/kategorier/konsert/country/umea',
    '186': 'alla-evenemang/kategorier/konsert/country/gavle',
    '96': 'alla-evenemang/kategorier/konsert/country/sundsvall',
    '159': 'alla-evenemang/kategorier/konsert/country/lulea',
    '177': 'alla-evenemang/kategorier/konsert/country/falun',
    '118': 'alla-evenemang/kategorier/konsert/country/eskilstuna',
    '121': 'alla-evenemang/kategorier/konsert/country/kristianstad',
    '158': 'alla-evenemang/kategorier/konsert/country/kalmar',
    '117': 'alla-evenemang/kategorier/konsert/country/ostersund',
    '97': 'alla-evenemang/kategorier/konsert/country/varberg',
    '104': 'alla-evenemang/kategorier/konsert/country/halmstad',
    '437': 'alla-evenemang/kategorier/konsert/country/falkenberg',
    '187': 'alla-evenemang/kategorier/konsert/country/lund',
    '163': 'alla-evenemang/kategorier/konsert/country/vaxjo',
    '127': 'alla-evenemang/kategorier/konsert/country/boras',
    '324': 'alla-evenemang/kategorier/konsert/country/trollhattan',
    '414': 'alla-evenemang/kategorier/konsert/country/uddevalla',
    '228': 'alla-evenemang/kategorier/konsert/country/visby',
    '221': 'alla-evenemang/kategorier/konsert/country/skovde',
    '105': 'alla-evenemang/kategorier/konsert/country/rattvik',
    '299': 'alla-evenemang/kategorier/konsert/country/lysekil',
    '106': 'alla-evenemang/kategorier/konsert/country/karlskrona',
    '109': 'alla-evenemang/kategorier/konsert/country/nykoping',
    '107': 'alla-evenemang/kategorier/konsert/country/pitea',
    '124': 'alla-evenemang/kategorier/konsert/country/sandviken',
    '344': 'alla-evenemang/kategorier/konsert/country/motala',
    '125': 'alla-evenemang/kategorier/konsert/country/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/konsert/country/soderhamn',
    '323': 'alla-evenemang/kategorier/konsert/country/bollnas',
    '453': 'alla-evenemang/kategorier/konsert/country/karlshamn',
    '522': 'alla-evenemang/kategorier/konsert/country/vanersborg',
    '100': 'alla-evenemang/kategorier/konsert/country/vadstena',
    '251': 'alla-evenemang/kategorier/konsert/country/kungsbacka',
    '119': 'alla-evenemang/kategorier/konsert/country/lidkoping',
    '424': 'alla-evenemang/kategorier/konsert/country/alingsas',
    '425': 'alla-evenemang/kategorier/konsert/country/hassleholm',
    '439': 'alla-evenemang/kategorier/konsert/country/soderkoping',
    '130': 'alla-evenemang/kategorier/konsert/country/stenungsund',
    '126': 'alla-evenemang/kategorier/konsert/country/arvika',
    '102': 'alla-evenemang/kategorier/konsert/country/borgholm',
    '362': 'alla-evenemang/kategorier/konsert/country/jarvso',
    '111': 'alla-evenemang/kategorier/konsert/country/furuvik',
    '122': 'alla-evenemang/kategorier/konsert/country/huskvarna'
  },
  'alla-evenemang/kategorier/konsert/schlager': {
    '112': 'alla-evenemang/kategorier/konsert/schlager/malmo',
    '24': 'alla-evenemang/kategorier/konsert/schlager/stockholm',
    '85': 'alla-evenemang/kategorier/konsert/schlager/goteborg',
    '94': 'alla-evenemang/kategorier/konsert/schlager/helsingborg',
    '114': 'alla-evenemang/kategorier/konsert/schlager/linkoping',
    '110': 'alla-evenemang/kategorier/konsert/schlager/orebro',
    '120': 'alla-evenemang/kategorier/konsert/schlager/uppsala',
    '160': 'alla-evenemang/kategorier/konsert/schlager/norrkoping',
    '162': 'alla-evenemang/kategorier/konsert/schlager/vasteras',
    '108': 'alla-evenemang/kategorier/konsert/schlager/karlstad',
    '123': 'alla-evenemang/kategorier/konsert/schlager/jonkoping',
    '116': 'alla-evenemang/kategorier/konsert/schlager/umea',
    '186': 'alla-evenemang/kategorier/konsert/schlager/gavle',
    '96': 'alla-evenemang/kategorier/konsert/schlager/sundsvall',
    '159': 'alla-evenemang/kategorier/konsert/schlager/lulea',
    '177': 'alla-evenemang/kategorier/konsert/schlager/falun',
    '118': 'alla-evenemang/kategorier/konsert/schlager/eskilstuna',
    '121': 'alla-evenemang/kategorier/konsert/schlager/kristianstad',
    '158': 'alla-evenemang/kategorier/konsert/schlager/kalmar',
    '117': 'alla-evenemang/kategorier/konsert/schlager/ostersund',
    '97': 'alla-evenemang/kategorier/konsert/schlager/varberg',
    '104': 'alla-evenemang/kategorier/konsert/schlager/halmstad',
    '437': 'alla-evenemang/kategorier/konsert/schlager/falkenberg',
    '187': 'alla-evenemang/kategorier/konsert/schlager/lund',
    '163': 'alla-evenemang/kategorier/konsert/schlager/vaxjo',
    '127': 'alla-evenemang/kategorier/konsert/schlager/boras',
    '324': 'alla-evenemang/kategorier/konsert/schlager/trollhattan',
    '414': 'alla-evenemang/kategorier/konsert/schlager/uddevalla',
    '228': 'alla-evenemang/kategorier/konsert/schlager/visby',
    '221': 'alla-evenemang/kategorier/konsert/schlager/skovde',
    '105': 'alla-evenemang/kategorier/konsert/schlager/rattvik',
    '299': 'alla-evenemang/kategorier/konsert/schlager/lysekil',
    '106': 'alla-evenemang/kategorier/konsert/schlager/karlskrona',
    '109': 'alla-evenemang/kategorier/konsert/schlager/nykoping',
    '107': 'alla-evenemang/kategorier/konsert/schlager/pitea',
    '124': 'alla-evenemang/kategorier/konsert/schlager/sandviken',
    '344': 'alla-evenemang/kategorier/konsert/schlager/motala',
    '125': 'alla-evenemang/kategorier/konsert/schlager/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/konsert/schlager/soderhamn',
    '323': 'alla-evenemang/kategorier/konsert/schlager/bollnas',
    '453': 'alla-evenemang/kategorier/konsert/schlager/karlshamn',
    '522': 'alla-evenemang/kategorier/konsert/schlager/vanersborg',
    '100': 'alla-evenemang/kategorier/konsert/schlager/vadstena',
    '251': 'alla-evenemang/kategorier/konsert/schlager/kungsbacka',
    '119': 'alla-evenemang/kategorier/konsert/schlager/lidkoping',
    '424': 'alla-evenemang/kategorier/konsert/schlager/alingsas',
    '425': 'alla-evenemang/kategorier/konsert/schlager/hassleholm',
    '439': 'alla-evenemang/kategorier/konsert/schlager/soderkoping',
    '130': 'alla-evenemang/kategorier/konsert/schlager/stenungsund',
    '126': 'alla-evenemang/kategorier/konsert/schlager/arvika',
    '102': 'alla-evenemang/kategorier/konsert/schlager/borgholm',
    '362': 'alla-evenemang/kategorier/konsert/schlager/jarvso',
    '111': 'alla-evenemang/kategorier/konsert/schlager/furuvik',
    '122': 'alla-evenemang/kategorier/konsert/schlager/huskvarna'
  },
  'alla-evenemang/kategorier/konsert/jazz': {
    '24': 'alla-evenemang/kategorier/konsert/jazz/stockholm',
    '85': 'alla-evenemang/kategorier/konsert/jazz/goteborg',
    '112': 'alla-evenemang/kategorier/konsert/jazz/malmo',
    '120': 'alla-evenemang/kategorier/konsert/jazz/uppsala',
    '110': 'alla-evenemang/kategorier/konsert/jazz/orebro',
    '114': 'alla-evenemang/kategorier/konsert/jazz/linkoping',
    '94': 'alla-evenemang/kategorier/konsert/jazz/helsingborg',
    '160': 'alla-evenemang/kategorier/konsert/jazz/norrkoping',
    '162': 'alla-evenemang/kategorier/konsert/jazz/vasteras',
    '108': 'alla-evenemang/kategorier/konsert/jazz/karlstad',
    '123': 'alla-evenemang/kategorier/konsert/jazz/jonkoping',
    '116': 'alla-evenemang/kategorier/konsert/jazz/umea',
    '186': 'alla-evenemang/kategorier/konsert/jazz/gavle',
    '96': 'alla-evenemang/kategorier/konsert/jazz/sundsvall',
    '159': 'alla-evenemang/kategorier/konsert/jazz/lulea',
    '177': 'alla-evenemang/kategorier/konsert/jazz/falun',
    '118': 'alla-evenemang/kategorier/konsert/jazz/eskilstuna',
    '121': 'alla-evenemang/kategorier/konsert/jazz/kristianstad',
    '158': 'alla-evenemang/kategorier/konsert/jazz/kalmar',
    '117': 'alla-evenemang/kategorier/konsert/jazz/ostersund',
    '97': 'alla-evenemang/kategorier/konsert/jazz/varberg',
    '104': 'alla-evenemang/kategorier/konsert/jazz/halmstad',
    '437': 'alla-evenemang/kategorier/konsert/jazz/falkenberg',
    '187': 'alla-evenemang/kategorier/konsert/jazz/lund',
    '163': 'alla-evenemang/kategorier/konsert/jazz/vaxjo',
    '127': 'alla-evenemang/kategorier/konsert/jazz/boras',
    '324': 'alla-evenemang/kategorier/konsert/jazz/trollhattan',
    '414': 'alla-evenemang/kategorier/konsert/jazz/uddevalla',
    '228': 'alla-evenemang/kategorier/konsert/jazz/visby',
    '221': 'alla-evenemang/kategorier/konsert/jazz/skovde',
    '105': 'alla-evenemang/kategorier/konsert/jazz/rattvik',
    '299': 'alla-evenemang/kategorier/konsert/jazz/lysekil',
    '106': 'alla-evenemang/kategorier/konsert/jazz/karlskrona',
    '109': 'alla-evenemang/kategorier/konsert/jazz/nykoping',
    '107': 'alla-evenemang/kategorier/konsert/jazz/pitea',
    '124': 'alla-evenemang/kategorier/konsert/jazz/sandviken',
    '344': 'alla-evenemang/kategorier/konsert/jazz/motala',
    '125': 'alla-evenemang/kategorier/konsert/jazz/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/konsert/jazz/soderhamn',
    '323': 'alla-evenemang/kategorier/konsert/jazz/bollnas',
    '453': 'alla-evenemang/kategorier/konsert/jazz/karlshamn',
    '522': 'alla-evenemang/kategorier/konsert/jazz/vanersborg',
    '100': 'alla-evenemang/kategorier/konsert/jazz/vadstena',
    '251': 'alla-evenemang/kategorier/konsert/jazz/kungsbacka',
    '119': 'alla-evenemang/kategorier/konsert/jazz/lidkoping',
    '424': 'alla-evenemang/kategorier/konsert/jazz/alingsas',
    '425': 'alla-evenemang/kategorier/konsert/jazz/hassleholm',
    '439': 'alla-evenemang/kategorier/konsert/jazz/soderkoping',
    '130': 'alla-evenemang/kategorier/konsert/jazz/stenungsund',
    '126': 'alla-evenemang/kategorier/konsert/jazz/arvika',
    '102': 'alla-evenemang/kategorier/konsert/jazz/borgholm',
    '362': 'alla-evenemang/kategorier/konsert/jazz/jarvso',
    '111': 'alla-evenemang/kategorier/konsert/jazz/furuvik',
    '122': 'alla-evenemang/kategorier/konsert/jazz/huskvarna'
  },
  'alla-evenemang/kategorier/teater/barnteater': {
    '24': 'alla-evenemang/kategorier/teater/barnteater/stockholm',
    '85': 'alla-evenemang/kategorier/teater/barnteater/goteborg',
    '112': 'alla-evenemang/kategorier/teater/barnteater/malmo',
    '120': 'alla-evenemang/kategorier/teater/barnteater/uppsala',
    '94': 'alla-evenemang/kategorier/teater/barnteater/helsingborg',
    '114': 'alla-evenemang/kategorier/teater/barnteater/linkoping',
    '110': 'alla-evenemang/kategorier/teater/barnteater/orebro',
    '160': 'alla-evenemang/kategorier/teater/barnteater/norrkoping',
    '162': 'alla-evenemang/kategorier/teater/barnteater/vasteras',
    '108': 'alla-evenemang/kategorier/teater/barnteater/karlstad',
    '123': 'alla-evenemang/kategorier/teater/barnteater/jonkoping',
    '116': 'alla-evenemang/kategorier/teater/barnteater/umea',
    '186': 'alla-evenemang/kategorier/teater/barnteater/gavle',
    '96': 'alla-evenemang/kategorier/teater/barnteater/sundsvall',
    '159': 'alla-evenemang/kategorier/teater/barnteater/lulea',
    '177': 'alla-evenemang/kategorier/teater/barnteater/falun',
    '118': 'alla-evenemang/kategorier/teater/barnteater/eskilstuna',
    '121': 'alla-evenemang/kategorier/teater/barnteater/kristianstad',
    '158': 'alla-evenemang/kategorier/teater/barnteater/kalmar',
    '117': 'alla-evenemang/kategorier/teater/barnteater/ostersund',
    '97': 'alla-evenemang/kategorier/teater/barnteater/varberg',
    '104': 'alla-evenemang/kategorier/teater/barnteater/halmstad',
    '437': 'alla-evenemang/kategorier/teater/barnteater/falkenberg',
    '187': 'alla-evenemang/kategorier/teater/barnteater/lund',
    '163': 'alla-evenemang/kategorier/teater/barnteater/vaxjo',
    '127': 'alla-evenemang/kategorier/teater/barnteater/boras',
    '324': 'alla-evenemang/kategorier/teater/barnteater/trollhattan',
    '414': 'alla-evenemang/kategorier/teater/barnteater/uddevalla',
    '228': 'alla-evenemang/kategorier/teater/barnteater/visby',
    '221': 'alla-evenemang/kategorier/teater/barnteater/skovde',
    '105': 'alla-evenemang/kategorier/teater/barnteater/rattvik',
    '299': 'alla-evenemang/kategorier/teater/barnteater/lysekil',
    '106': 'alla-evenemang/kategorier/teater/barnteater/karlskrona',
    '109': 'alla-evenemang/kategorier/teater/barnteater/nykoping',
    '107': 'alla-evenemang/kategorier/teater/barnteater/pitea',
    '124': 'alla-evenemang/kategorier/teater/barnteater/sandviken',
    '344': 'alla-evenemang/kategorier/teater/barnteater/motala',
    '125': 'alla-evenemang/kategorier/teater/barnteater/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/teater/barnteater/soderhamn',
    '323': 'alla-evenemang/kategorier/teater/barnteater/bollnas',
    '453': 'alla-evenemang/kategorier/teater/barnteater/karlshamn',
    '522': 'alla-evenemang/kategorier/teater/barnteater/vanersborg',
    '100': 'alla-evenemang/kategorier/teater/barnteater/vadstena',
    '251': 'alla-evenemang/kategorier/teater/barnteater/kungsbacka',
    '119': 'alla-evenemang/kategorier/teater/barnteater/lidkoping',
    '424': 'alla-evenemang/kategorier/teater/barnteater/alingsas',
    '425': 'alla-evenemang/kategorier/teater/barnteater/hassleholm',
    '439': 'alla-evenemang/kategorier/teater/barnteater/soderkoping',
    '130': 'alla-evenemang/kategorier/teater/barnteater/stenungsund',
    '126': 'alla-evenemang/kategorier/teater/barnteater/arvika',
    '102': 'alla-evenemang/kategorier/teater/barnteater/borgholm',
    '362': 'alla-evenemang/kategorier/teater/barnteater/jarvso',
    '111': 'alla-evenemang/kategorier/teater/barnteater/furuvik',
    '122': 'alla-evenemang/kategorier/teater/barnteater/huskvarna'
  },
  'alla-evenemang/kategorier/teater/opera': {
    '112': 'alla-evenemang/kategorier/teater/opera/malmo',
    '94': 'alla-evenemang/kategorier/teater/opera/helsingborg',
    '120': 'alla-evenemang/kategorier/teater/opera/uppsala',
    '24': 'alla-evenemang/kategorier/teater/opera/stockholm',
    '85': 'alla-evenemang/kategorier/teater/opera/goteborg',
    '110': 'alla-evenemang/kategorier/teater/opera/orebro',
    '114': 'alla-evenemang/kategorier/teater/opera/linkoping',
    '160': 'alla-evenemang/kategorier/teater/opera/norrkoping',
    '162': 'alla-evenemang/kategorier/teater/opera/vasteras',
    '108': 'alla-evenemang/kategorier/teater/opera/karlstad',
    '123': 'alla-evenemang/kategorier/teater/opera/jonkoping',
    '116': 'alla-evenemang/kategorier/teater/opera/umea',
    '186': 'alla-evenemang/kategorier/teater/opera/gavle',
    '96': 'alla-evenemang/kategorier/teater/opera/sundsvall',
    '159': 'alla-evenemang/kategorier/teater/opera/lulea',
    '177': 'alla-evenemang/kategorier/teater/opera/falun',
    '118': 'alla-evenemang/kategorier/teater/opera/eskilstuna',
    '121': 'alla-evenemang/kategorier/teater/opera/kristianstad',
    '158': 'alla-evenemang/kategorier/teater/opera/kalmar',
    '117': 'alla-evenemang/kategorier/teater/opera/ostersund',
    '97': 'alla-evenemang/kategorier/teater/opera/varberg',
    '104': 'alla-evenemang/kategorier/teater/opera/halmstad',
    '437': 'alla-evenemang/kategorier/teater/opera/falkenberg',
    '187': 'alla-evenemang/kategorier/teater/opera/lund',
    '163': 'alla-evenemang/kategorier/teater/opera/vaxjo',
    '127': 'alla-evenemang/kategorier/teater/opera/boras',
    '324': 'alla-evenemang/kategorier/teater/opera/trollhattan',
    '414': 'alla-evenemang/kategorier/teater/opera/uddevalla',
    '228': 'alla-evenemang/kategorier/teater/opera/visby',
    '221': 'alla-evenemang/kategorier/teater/opera/skovde',
    '105': 'alla-evenemang/kategorier/teater/opera/rattvik',
    '299': 'alla-evenemang/kategorier/teater/opera/lysekil',
    '106': 'alla-evenemang/kategorier/teater/opera/karlskrona',
    '109': 'alla-evenemang/kategorier/teater/opera/nykoping',
    '107': 'alla-evenemang/kategorier/teater/opera/pitea',
    '124': 'alla-evenemang/kategorier/teater/opera/sandviken',
    '344': 'alla-evenemang/kategorier/teater/opera/motala',
    '125': 'alla-evenemang/kategorier/teater/opera/ornskoldsvik',
    '657': 'alla-evenemang/kategorier/teater/opera/soderhamn',
    '323': 'alla-evenemang/kategorier/teater/opera/bollnas',
    '453': 'alla-evenemang/kategorier/teater/opera/karlshamn',
    '522': 'alla-evenemang/kategorier/teater/opera/vanersborg',
    '100': 'alla-evenemang/kategorier/teater/opera/vadstena',
    '251': 'alla-evenemang/kategorier/teater/opera/kungsbacka',
    '119': 'alla-evenemang/kategorier/teater/opera/lidkoping',
    '424': 'alla-evenemang/kategorier/teater/opera/alingsas',
    '425': 'alla-evenemang/kategorier/teater/opera/hassleholm',
    '439': 'alla-evenemang/kategorier/teater/opera/soderkoping',
    '130': 'alla-evenemang/kategorier/teater/opera/stenungsund',
    '126': 'alla-evenemang/kategorier/teater/opera/arvika',
    '102': 'alla-evenemang/kategorier/teater/opera/borgholm',
    '362': 'alla-evenemang/kategorier/teater/opera/jarvso',
    '111': 'alla-evenemang/kategorier/teater/opera/furuvik',
    '122': 'alla-evenemang/kategorier/teater/opera/huskvarna'
  }
}

export default seoCityRedirects
